import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { TripAttributesGps, VisitGps } from "../dto/visit-gps.interface";

export function extractCustomProps(trip: TripAttributesGps): Record<string, any> {
  const dateHourPipe = new FormatOtherDateHourPipe();

  if (!trip.locations || trip.locations.length === 0) return {};

  const firstLocation = trip.locations[0];
  const velocity = firstLocation.speed * 3.6; // m/s a km/h
  const odometer = firstLocation.odometer * 0.001; // metros a km

  return {
    'Nombre': firstLocation.userName,
    'Odómetro': `${odometer.toFixed(2)} km`,
    'Velocidad': `${velocity.toFixed(2)} km/h`,
    'Última réplica': dateHourPipe.transform(firstLocation.timestamp, true),
  };
}

export function extractCustomModalProps(visit: VisitGps, trip: TripAttributesGps): Record<string, any> {
  const dateHourPipe = new FormatOtherDateHourPipe();

  if (!visit.location) return {};

  const firstLocation = visit.location;
  const velocity = firstLocation.coords.speed * 3.6; // m/s a km/h
  const odometer = firstLocation.odometer * 0.001; // metros a km

  return {
    'Usuario': trip.user?.user_login?.username ?? 'Sin usuario',
    'Odómetro': `${odometer.toFixed(2)} km`,
    'Velocidad': `${velocity.toFixed(2)} km/h`,
    'Última réplica': dateHourPipe.transform(firstLocation.timestamp, true),
  };
}